var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1e993a1790da53652ab320fed038cd3de263ae3c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@lando-dr"]={id:"1e993a1790da53652ab320fed038cd3de263ae3c"};
      